import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tablet } from '@hellodarwin/core/lib/components/common/Media';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import { InfoTileContainer } from '../styles';
const AssetCardInfoTile = ({ infoPositionLeft, infoPositionTop, author, role, type, }) => {
    const theme = useTheme();
    if (type === 'Citation' || !author) {
        return null;
    }
    return (_jsx(Tablet, { direction: "up", children: _jsxs(InfoTileContainer, { style: {
                top: `${infoPositionTop || 100}%`,
                left: `${infoPositionLeft || 100}%`,
                transform: 'translate(-50%,-50%)',
                width: 180,
                height: 93,
                zIndex: 100,
            }, children: [_jsx(Typography, { color: theme.colors.white_1, elementTheme: "h6", nowrap: true, style: { fontSize: 16 }, children: author }), !!role && (_jsx(Typography, { color: theme.colors.white_1, elementTheme: "body3", style: { fontSize: 12 }, children: role }))] }) }));
};
export default AssetCardInfoTile;
